import {Injectable} from '@angular/core';
import {OAuthService} from 'angular-oauth2-oidc';

@Injectable({
  providedIn: 'root',
})
export class InactivityService {
  private timeoutId: any;
  private inactivityLimit = 3600000;

  constructor(private oauthService: OAuthService) {
    this.listenForUserActivity();
  }

  listenForUserActivity() {
    ['click', 'mousemove', 'keydown'].forEach((event) => {
      document.addEventListener(event, () => this.resetTimer());
    });
  }

  startWatching() {
    this.resetTimer();
  }

  stopWatching() {
    clearTimeout(this.timeoutId);
  }

  private resetTimer() {
    clearTimeout(this.timeoutId);
    this.timeoutId = setTimeout(() => this.logoutUser(), this.inactivityLimit);
  }

  private logoutUser() {
    this.oauthService.logOut();
  }
}
